export default "__VITE_ASSET__Cv14OSBo__"